import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/lib/site";
export default function FAQSection() {
  return (
   
      <section data-testid="faq-section" className="relative py-24 md:py-36 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Reveal className="text-center">
            <div className="overline text-stenzia-green">FAQ</div>
            <h2 className="mt-6 font-display font-light text-4xl md:text-5xl tracking-tighter text-charcoal leading-[1.02]">Frequently asked.</h2>
            <p className="mt-4 text-charcoal/60 max-w-xl mx-auto">Everything you need to know about Stenzia&apos;s display systems, lead times, customisation and export.</p>
          </Reveal>

          <Reveal delay={1}>
            <Accordion type="single" collapsible className="mt-14" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="group border-b border-charcoal/10 hover:border-charcoal/25 hover:bg-black/[0.025] rounded-md transition-colors duration-300"
                >
                  <AccordionTrigger className="px-3 py-6 text-left font-display text-base md:text-lg text-charcoal group-hover:text-stenzia-green hover:text-stenzia-green hover:no-underline tracking-tight transition-colors duration-300 cursor-pointer [&>svg]:transition-colors [&>svg]:duration-300 group-hover:[&>svg]:text-stenzia-green">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="px-3 text-charcoal/65 text-sm md:text-base leading-relaxed pb-6 pr-8">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
  );
}